import { Stack } from '@mui/material';
import { SeznamAutocomplete } from '../../../types/external/seznamAutocomplete';
import { AccidentUserType, RegistryIdName } from '../../types/accident';
import { UserPrefix } from '../AccidenCreatingStepCustomerInformations';
import { AddressFields } from './AddressFields';
import { BirthNumberFields } from './BirthNumberFields';
import { CompanyFields } from './CompanyFields';
import { PersonFields } from './PersonFields';

/** Sekce Majitel / Provozovatel – sdílí stejnou strukturu polí */
export const ParticipantFields = ({
  prefix,
  control,
  userType,
  ico,
  birthNumber,
  isAresDataLoading,
  countryList,
  autocompleteResults,
  onAresClick,
  onSystemSearch,
  onBirthNumberSearch,
  onAutocompleteSearch,
  onAutocompleteSelect,
  isLoadingAddressData
}: {
  prefix: UserPrefix;
  control: any;
  userType: AccidentUserType;
  ico: string;
  birthNumber: string | undefined;
  isAresDataLoading?: boolean;
  countryList?: RegistryIdName[];
  autocompleteResults: SeznamAutocomplete[];
  onAresClick: () => void;
  onSystemSearch: () => void;
  onBirthNumberSearch: () => void;
  onAutocompleteSearch: (value: string) => void;
  onAutocompleteSelect: (value: SeznamAutocomplete) => void;
  isLoadingAddressData?: boolean;
}) => {
  const isPerson = userType === AccidentUserType.Person;
  const isBusinessMan = userType === AccidentUserType.BusinessMan;
  const isCompany = userType === AccidentUserType.Company;
  const isCompanyOrBusinessMan = isCompany || isBusinessMan;

  return (
    <Stack gap={2} mt={3}>
      {/* Titul, Jméno, Příjmení – fyzická osoba a podnikatel */}
      {!isCompany && <PersonFields prefix={prefix} control={control} />}

      {/* Rodné číslo, Datum narození – fyzická osoba a podnikatel */}
      {(isPerson || isBusinessMan) && (
        <BirthNumberFields prefix={prefix} control={control} birthNumber={birthNumber} onSearch={onBirthNumberSearch} />
      )}

      {/* IČO, DIČ, Plátce DPH – firma a podnikatel */}
      {isCompanyOrBusinessMan && (
        <CompanyFields
          prefix={prefix}
          control={control}
          ico={ico}
          showCompanyName={isCompany}
          isAresDataLoading={isAresDataLoading}
          onAresClick={onAresClick}
          onSystemSearch={onSystemSearch}
        />
      )}

      <AddressFields
        prefix={prefix}
        control={control}
        countryList={countryList}
        autocompleteResults={autocompleteResults}
        onAutocompleteSearch={onAutocompleteSearch}
        onAutocompleteSelect={onAutocompleteSelect}
        isLoadingAddressData={isLoadingAddressData}
      />
    </Stack>
  );
};
